import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CustomHierarchyPageLoadModel, HierarchyModel } from './add-custom-hierarchy.models';

@Injectable({
    providedIn: 'root'
})
export class AddCustomHierarchyService {

    constructor(
        private api: CVApiService,
    ) { 

    }

    public async loadCustomHierarchies() {
        let response = await this.api.get<CustomHierarchyPageLoadModel>("/api/v1/pipeline-config/custom-hierarchies/popup-content");
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        throw response;
    }

    public async saveCustomHierarchy(model: HierarchyModel) {
        let response = await this.api.post<HierarchyModel>("/api/v1/pipeline-config/custom-hierarchies/hierarchy", model);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        throw response;
    }
}